<template>
	<div class="application--wrapper__outer  compact-padding">
		<div class="application--wrapper__inner ">
			<slot name="heading"></slot>

			<form @submit.prevent="handleSubmit" id="form">
				<template v-if="isOpenApplication" class="form--wrapper">
					<h1 class="heading--sm heading text-capitalize text-center">
						Questions
					</h1>
					<p class="form--input">
						<label for="purpose"
							>What is it that you would like to do at Bohemia
							Interactive?</label
						>
					</p>
					<div class="divider-md"></div>
					<input
						id="purpose"
						name="purpose"
						v-model="purpose"
						type="text"
						class="input-text__form"
						@input="$v.purpose.$touch()"
						:class="{
							error: $v.purpose.$error,
							valid: $v.purpose.$dirty && !$v.purpose.$invalid
						}"
					/>
					<span
						class="form-group__message"
						v-if="!$v.purpose.required && $v.purpose.$error"
						>Field is required</span
					>
					<span
						class="form-group__message"
						v-if="!$v.purpose.maxLength && $v.purpose.$error"
						>Max length is
						{{ $v.purpose.$params.maxLength.max }} letters.</span
					>

					<SingleSelect
						label="Please select a discipline that best matches your interests.* (Choose one)"
						v-on:input="$v.departmentId.$touch()"
						v-model="departmentId"
						name="departmentId"
						class="multiple-select"
						:multirow="true"
						placeholder="Choose only one (1)"
						:list="departmentsBlock"
						:error-class="{
							error: $v.departmentId.$error,
							valid:
								$v.departmentId.$dirty &&
								!$v.departmentId.$invalid
						}"
					></SingleSelect>
					<span
						class="form-group__message"
						v-if="
							!$v.departmentId.required && $v.departmentId.$error
						"
						>Field is required</span
					>

					<SingleSelect
						label="How would you rate your experience in this field?"
						v-on:input="$v.experienceId.$touch()"
						name="experienceId"
						v-model="experienceId"
						class="multiple-select"
						placeholder="Choose..."
						:list="experiences"
						:error-class="{
							error: $v.experienceId.$error,
							valid:
								$v.experienceId.$dirty &&
								!$v.experienceId.$invalid
						}"
					></SingleSelect>
					<span
						class="form-group__message"
						v-if="
							!$v.experienceId.required && $v.experienceId.$error
						"
						>Field is required</span
					>
				</template>
				<h1 class="heading--sm heading text-center">
					Personal Information
				</h1>
				<p class="form--input">
					<label for="first_name">First name *</label>
				</p>
				<div class="divider-md"></div>
				<input
					id="first_name"
					name="first_name"
					v-model="firstName"
					type="text"
					class="input-text__form"
					v-on:input="$v.firstName.$touch()"
					v-bind:class="{
						error: $v.firstName.$error,
						valid: $v.firstName.$dirty && !$v.firstName.$invalid
					}"
				/>
				<span
					class="form-group__message"
					v-if="!$v.firstName.required && $v.firstName.$error"
					>Field is required</span
				><span
					class="form-group__message"
					v-if="!$v.firstName.minLength && $v.firstName.$error"
					>First name must have at least
					{{ $v.firstName.$params.minLength.min }} letters.</span
				>

				<p class="form--input">
					<label for="last_name">Last name *</label>
				</p>
				<div class="divider-md"></div>
				<input
					id="last_name"
					name="last_name"
					v-model="lastName"
					class="input-text__form"
					type="text"
					v-on:input="$v.lastName.$touch()"
					v-bind:class="{
						error: $v.lastName.$error,
						valid: $v.lastName.$dirty && !$v.lastName.$invalid
					}"
				/>

				<span
					class="form-group__message"
					v-if="!$v.lastName.required && $v.lastName.$error"
					>Field is required</span
				><span
					class="form-group__message"
					v-if="!$v.lastName.minLength && $v.lastName.$error"
					>Last name must have at least
					{{ $v.lastName.$params.minLength.min }} letters.</span
				>

				<p class="form--input">
					<label for="email">E-mail address *</label>
				</p>
				<div class="divider-md"></div>
				<input
					id="email"
					name="email"
					v-model="email"
					class="input-text__form"
					type="text"
					placeholder="emailexample@email.com"
					v-on:input="$v.email.$touch()"
					v-bind:class="{
						error: $v.email.$error,
						valid: $v.email.$dirty && !$v.email.$invalid
					}"
				/>
				<span
					class="form-group__message"
					v-if="!$v.email.email && $v.email.$error"
					>Please, provide valid email address</span
				>
				<span
					class="form-group__message"
					v-if="!$v.email.required && $v.email.$error"
					>Field is required</span
				>
				<span
					class="form-group__message"
					v-if="!$v.email.minLength && $v.email.$error"
					>Email must have at least
					{{ $v.email.$params.minLength.min }} letters.</span
				>

				<p class="form--input">
					<label for="phone">Phone number (optional)</label>
				</p>
				<div class="divider-md"></div>
				<input
					id="phone"
					name="phone"
					v-model="phone"
					class="input-text__form"
					type="text"
					placeholder="(+000) 123 123 123"
				/>

				<p class="form--input">
					<label for="salary_expectation"
						>Expected monthly gross salary (optional)</label
					>
				</p>
				<div class="divider-md"></div>

				<div class="form--input__salary">
					<InputWithSelect
						name="salaryExpectation"
						@salary-expectation="salaryExpectation"
						@salary-currency="salaryCurrency"
						class="multiple-select"
						placeholder="Currency"
						:list="currencies"
						:error-class="{
							error: $v.currencyId.$error,
							valid:
								$v.currencyId.$dirty && !$v.currencyId.$invalid
						}"
					></InputWithSelect>
				</div>
				<p class="form--input">
					<label for="possible_start"
						>Possible start date (optional)</label
					>
				</p>
				<div class="divider-md"></div>
				<input
					id="possible_start"
					name="possible_start"
					v-model="possible_start"
					class="input-text__form"
					type="date"
				/>
				<p class="form--input">
					<label for="hear_from"
						>How did you learn about the position ?
						(optional)</label
					>
				</p>
				<div class="divider-md"></div>
				<input
					id="hear_from"
					name="hear_from"
					v-model="hear_from"
					class="input-text__form"
					type="text"
					placeholder="e.g. LinkedIn, Facebook, etc."
				/>
				<div class="divider--sm"></div>

				<p class="form--input radio">
					<label
						>Are you entitled to work in EU (EU residentship, visa,
						work permit, other)? *</label
					>
				</p>
				<div class="divider-md"></div>
				<span
					class="form-group__message"
					v-if="
						!$v.eu_eligibility.required && $v.eu_eligibility.$error
					"
					>Field is required</span
				>
				<label class="radio-container"
					>No
					<input type="radio" v-model="eu_eligibility" :value="0" />
					<span class="checkmark"></span>
				</label>
				<label class="radio-container"
					>Yes
					<input type="radio" v-model="eu_eligibility" :value="1" />
					<span class="checkmark"></span>
				</label>

				<div class="mandatory-watermark pull-right">
					* Mandatory fields
				</div>

				<div class="dividing-line"></div>
				<attachments
					@input="isCVattached"
					v-model="attachments"
					:error-class="{
						error: $v.CVAttached.$error,
						valid: $v.CVAttached.$dirty && !$v.CVAttached.$invalid
					}"
				></attachments>

				<div class="divider"></div>

				<text-area v-model="gdpr_accepted"></text-area>
				<div class="divider"></div>
				<div v-if="apiError" class="form-error-wraper">
					<p class="form-response-error">{{ apiError }}</p>
				</div>
				<div class="submit-wrapper">
					<div class=" button-wrapper" v-if="!isLoading">
						<button
							type="submit"
							:class="`position-item--${position_color}`"
						>
							Submit
						</button>
					</div>
					<div class="captcha-wrapper">
						<vue-recaptcha
							v-if="recaptchaSettings"
							size="invisible"
							badge="inline"
							ref="recaptcha"
							@verify="onVerify"
							@expired="onExpired"
							:sitekey="recaptchaSettings.key"
						></vue-recaptcha>
					</div>
				</div>
				<!--<span class="text-red text-bold">SUBMIT BUTTON TEMPORARILY REMOVED FOR SAFETY PURPOSES AND WELL BEING OF OUR SERVERS :) </span>-->
				<div class="divider"></div>

				<accordion></accordion>
			</form>
		</div>
		<popup-notification ref="successNotification"></popup-notification>
	</div>
</template>

<script>
import BasicButton from "../BasicButton";
import { addErrorNotification } from "../../utils/notifications";

import {
	minLength,
	required,
	requiredUnless,
	maxLength,
	email
} from "vuelidate/lib/validators";
import VueRecaptcha from "vue-recaptcha";
import {
	postApplication,
	postOpenApplication
} from "../../services/submitApplication";
import Attachments from "./Attachments";
import SingleSelect from "./../common/SingleSelect";
import { mapActions, mapState } from "vuex";
import TextArea from "../common/GDPR";
import Accordion from "../common/Accordion";
import InputWithSelect from "../common/InputWithSelect";
import PopupNotification from "../common/PopupNotification";
import { getCaptcha } from "../../services/captcha";
import EventBus from "../../EventBus";

export default {
	components: {
		Accordion,
		TextArea,
		Attachments,
		BasicButton,
		VueRecaptcha,
		SingleSelect,
		InputWithSelect,
		PopupNotification
	},
	name: "ApplicationForm",
	props: {
		position_id: {
			default: 0
		},
		position_color: {
			default: 0
		},
		isOpenApplication: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			apiError: null,
			experienceId: null,
			departmentId: null,
			currencyId: null,
			purpose: null,
			firstName: null,
			lastName: null,
			email: null,
			phone: null,
			eu_eligibility: false,
			gdpr_accepted: false,
			portfolio_link: null,
			additional_link: null,
			salary_expectation: null,
			possible_start: null,
			hear_frrom: null,
			captchaResponse: null,
			isLoading: false,
			recaptchaSettings: null,
			CVAttached: false,
			attachments: [
				{
					id: 1,
					label: "CV / Resume *",
					file: null
				},
				{
					id: 2,
					label: "Cover Letter",
					file: null
				},
				{
					id: 3,
					label: "Portfolio / Other Files",
					file: null
				}
			],
			portfolio: "",
			experiences: [
				{ id: 1, name: "Junior / Entry-level" },
				{ id: 2, name: "Intermediate / Mid-level" },
				{ id: 3, name: "Senior / Expert" },
				{ id: 4, name: "Lead" },
				{ id: 5, name: "Manager" }
			],
			currencies: [
				{ id: 1, name: "CZK" },
				{ id: 2, name: "EUR" },
				{ id: 3, name: "USD" },
				{ id: 4, name: "GBP" },
				{ id: 5, name: "THB" }
			]
		};
	},
	validations() {
		let rules = {
			firstName: {
				required,
				minLength: minLength(1)
			},
			lastName: {
				required,
				minLength: minLength(1)
			},
			email: {
				required,
				minLength: minLength(1),
				email
			},
			eu_eligibility: {
				required,
				default: false
			},
			currencyId: {
				required: requiredUnless(function() {
					return !this.salary_expectation;
				})
			},
			CVAttached: {
				required,
				attached: value => this.CVAttached === true
			}
		};
		if (this.isOpenApplication) {
			rules = Object.assign(
				{
					purpose: {
						required,
						maxLength: maxLength(200)
					},
					departmentId: {
						required
					},
					experienceId: {
						required
					}
				},
				rules
			);
		}
		return rules;
	},
	mounted() {
		this.getFilters();
		EventBus.$on("portfolio_link", portfolioLink => {
			this.portfolio_link = portfolioLink;
		});
		EventBus.$on("additional_link", additionalLink => {
			this.additional_link = additionalLink;
		});
	},
	created() {
		getCaptcha().then(response => {
			this.recaptchaSettings = response;
		});
	},
	methods: {
		...mapActions("jobs", ["getFilters"]),

		salaryExpectation(salary) {
			this.salary_expectation = salary;
		},
		salaryCurrency(currency) {
			this.currencyId = currency;
		},
		onVerify(value) {
			this.captchaResponse = value;
			this.execSubmit();
		},
		onExpired() {
			this.$refs.recaptcha.reset();
			this.captchaResponse = null;
		},
		onExecute() {
			this.$refs.recaptcha.execute();
		},
		isCVattached() {
			let cv = this.attachments
				.filter(obj => {
					return obj.id === 1;
				})
				.some(attachment => attachment.file != null);
			if (this.attachments.length > 0 && cv) {
				this.CVAttached = true;
			} else {
				this.CVAttached = false;
			}
		},
		handleSubmit() {
			this.isCVattached();
			// this.execSubmit();
			this.$v.$touch();
			if (!this.$v.$invalid && !this.$v.$error) {
				this.onExecute();
			} else {
				this.$scrollTo("#form", 500, {});
			}
		},
		async execSubmit() {
			let formData = new FormData();
			let departmentName = this.departments.find(element => {
				if (element.id === this.departmentId) {
					return element.name;
				}
			});
			if (departmentName) {
				departmentName = departmentName.name;
			}
			const experience = this.experiences.find(
				element => element.id === this.experienceId
			);
			const experienceName = experience ? experience.name : null;

			const currency = this.currencies.find(
				element => element.id === this.currencyId
			);
			const currencyName = currency ? currency.name : null;

			formData.append("first_name", this.firstName);
			formData.append("last_name", this.lastName);
			formData.append("email", this.email);
			formData.append("phone", this.phone);
			formData.append("purpose", this.purpose);
			formData.append("eu_eligibility", this.eu_eligibility);
			formData.append("position_id", this.position_id);
			formData.append("department_name", departmentName);
			formData.append("experience_name", experienceName);
			formData.append("g-recaptcha-response", this.captchaResponse);
			formData.append("hear_from", this.hear_from);
			if (this.attachments) {
				for (let i = 0; i < this.attachments.length; i++) {
					if (this.attachments[i].file) {
						formData.append(
							"attachments",
							this.attachments[i].file
						);
					}
				}
			}
			formData.append("gdpr_accepted", this.gdpr_accepted);
			formData.append("portfolio_link", this.portfolio_link);
			formData.append("additional_link", this.additional_link);

			//ifs becaouse of JIRA returning wrong response
			if (this.salary_expectation) {
				formData.append("salary_expectation", this.salary_expectation);
			}
			if (currencyName) {
				formData.append("salary_expectation_currency", currencyName);
			}
			formData.append("possible_start", this.possible_start);

			this.$gtm.trackEvent({
				event: "SubmitApplication",
				category: "FormSubmit",
				action: "Submit",
				label: "Submit Job Application",
				value: 1,
				noninteraction: false // Optional
			});

			this.isLoading = true;
			try {
				if (this.isOpenApplication) {
					await postOpenApplication(formData);
					this.isLoading = false;
					this.firstName = null;
					this.lastName = null;
					this.email = null;
					this.phone = null;
					this.eu_eligibility = false;
					this.purpose = null;
					this.experienceId = null;
					this.departmentId = null;
					for (let i = 0; i < this.attachments.length; i++) {
						this.attachments[i].file = null;
					}
					this.gdpr_accepted = false;
					this.portfolio_link = null;
					this.additional_link = null;
					this.salary_expectation = null;
					this.currencyId = null;
					this.possible_start = null;
					this.hear_from = null;
				} else {
					await postApplication(this.position_id, formData);
					this.isLoading = false;
					this.firstName = null;
					this.lastName = null;
					this.email = null;
					this.phone = null;
					this.eu_eligibility = false;
					this.purpose = null;
					this.experienceId = null;
					this.departmentId = null;
					for (let i = 0; i < this.attachments.length; i++) {
						this.attachments[i].file = null;
					}
					this.gdpr_accepted = false;
					this.portfolio_link = null;
					this.additional_link = null;
					this.salary_expectation = null;
					this.currencyId = null;
					this.possible_start = null;
					this.hear_frrom = null;
				}
				this.$v.$reset();
				this.$refs.successNotification.open();
				this.apiError = null;
			} catch (err) {
				if (err.response) {
					const responseData = err.response.data;
					this.apiError = responseData.message;
					addErrorNotification(this.apiError);
				} else if (err.request) {
					const errMsg =
						"Server is not available. Please contact us via email: jobs@bohemia.net";
					this.apiError = errMsg;
					addErrorNotification(errMsg);
				} else {
					const errMsg =
						"Server is not available. Please contact us via email: jobs@bohemia.net";
					addErrorNotification(errMsg);
				}
				addErrorNotification(
					"Something went wrong. Please contact us via email: jobs@bohemia.net"
				);
				this.$refs.recaptcha.reset();
				this.isLoading = false;
			}
		}
	},
	computed: {
		slug() {
			return this.$route.params.slug;
		},
		departmentsBlock() {
			let items = [];
			if (
				this.departments &&
				this.departments &&
				this.departments.length > 0
			) {
				let blockLimit = 6;
				let blockCounter = Math.ceil(
					this.departments.length / blockLimit
				);
				for (let j = 0; j < blockCounter; j++) {
					let block = [];
					for (let i = 0; i < blockLimit; i++) {
						let blockNumber = j * blockLimit + i;
						if (blockNumber < this.departments.length) {
							block.push(this.departments[blockNumber]);
						}
					}
					items.push(block);
				}
			}
			return items;
		},
		...mapState({
			departments: state => state.jobs.departments
		})
	}
};
</script>

<style scoped lang="scss" type="text/scss">
@import "../../assets/scss/globals";

.form-error-wraper {
	margin-top: 20px;
	display: flex;
	justify-content: left;
}
.form-response-error {
	font-weight: 500;
	color: #c32121;
	font-size: 16px;
}
.submit-wrapper {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
}

.captcha-wrapper {
	padding-top: 20px;
}

.button-wrapper {
	padding-top: 20px;
	padding-right: 10px;
	flex: 1;
	button {
		border: none;
	}
}

.input-text__form {
	color: #1a1a1a;
}

.mandatory-watermark {
	color: #a5a5a5;
	@media (max-width: $compact) {
		margin-top: 30px;
	}
}

.dividing-line {
	border-bottom: 1px solid #e7e6e6;
	margin-top: 60px;
	margin-bottom: 40px;
}

.form--input {
	margin-bottom: 20px;
	margin-top: 50px;
	label {
		font-family: "Inter UI", sans-serif;
		font-size: 22px;
		line-height: 28px;
		letter-spacing: 0.02px;
		font-weight: 400;
	}
	&__salary {
		display: flex;
	}
}

.radio {
	margin-top: 0;
	margin-bottom: 40px;
}

.radio-container {
	display: inline-block;
	position: relative;
	padding-left: 28px;
	padding-top: 3px;
	margin-bottom: 12px;
	margin-right: 50px;
	cursor: pointer;
	font-size: 14px;
	font-family: "Inter UI", sans-serif;
	line-height: 16.8px;
	font-weight: 700;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

/* Hide the browser's default checkbox */
.radio-container input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
}

.checkmark {
	position: absolute;
	top: 0;
	left: 0;
	height: 20px;
	width: 20px;
	background-color: #fff;
	border-radius: 50%;
	border: 2px solid #1a1a1a;
}

/* On mouse-over, add a grey background color */
.radio-container:hover input ~ .checkmark {
	background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.radio-container input:checked ~ .checkmark {
	background-color: #fff;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
	content: "";
	position: absolute;
	display: none;
}

/* Show the indicator (dot/circle) when checked */
.radio-container input:checked ~ .checkmark:after {
	display: block;
}

/* Style the indicator (dot/circle) */
.radio-container .checkmark:after {
	top: 3px;
	left: 3px;
	width: 10px;
	height: 10px;
	border-radius: 50%;
	background: #000;
}

.form-group__message {
	color: #c32121;
	font-size: 12px;
}

.application--wrapper__outer {
	background-color: $alabaster;
	position: relative;
}

.application--wrapper__inner {
	max-width: 1000px;
	margin: auto;
}

hr {
	display: block;
	height: 1px;
	border: 0;
	border-top: 1px solid gray;
	margin: 1em 0;
	padding: 0;
}

.heading {
	margin: auto;
	margin-bottom: 60px;
	padding-top: 1em;
	font-size: 32px;
	letter-spacing: 0.64px;

	@media (max-width: $tablet) {
		max-width: 100%;
	}
}

.paragraph {
	font-size: 16px;
	margin: auto;

	@media (max-width: $tablet) {
		max-width: 100%;
	}
}

.error {
	border-color: red;
	background: #fdd;
}

.error:focus {
	outline-color: #f99;
}

.valid {
	border-color: #70c165;
}

.valid:focus {
	outline-color: #70c165;
}

.divider--sm {
	padding-bottom: 2em;
}

button[type="submit"] {
	color: #fff;
	padding: 12px 80px;
	border-radius: 30px;
	cursor: pointer;
	font-size: 20px;
}

button[type="submit"]:hover {
}

.form--wrapper {
	width: 1000px;
}
</style>



// WEBPACK FOOTER //
// src/components/applicationPageComponents/ApplicationForm.vue